/**
 * A job's extra search titles: titles the search looks for besides the job's own, such as "Lifecycle Marketer" on a
 * Growth Marketer job. The rules match finlay-api's (JobSearchTitles), so the form never sends a list it refuses.
 */

export const MAX_SEARCH_TITLES = 10;
const MAX_SEARCH_TITLE_LENGTH = 100;

/** The titles with `raw` added: its spaces collapsed, and nothing added for a blank or a repeat in other casing. */
export function addSearchTitle(
  titles: string[],
  raw: string,
): { titles: string[]; error?: string } {
  const title = raw.split(/\s+/).filter(Boolean).join(' ');
  if (!title) return { titles };
  if (titles.some((t) => t.toLowerCase() === title.toLowerCase())) {
    return { titles };
  }
  if (title.length > MAX_SEARCH_TITLE_LENGTH) {
    return {
      titles,
      error: `A title can be at most ${MAX_SEARCH_TITLE_LENGTH} characters.`,
    };
  }
  if (titles.length >= MAX_SEARCH_TITLES) {
    return { titles, error: `Add at most ${MAX_SEARCH_TITLES} titles.` };
  }
  return { titles: [...titles, title] };
}
